import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});


  // お問い合わせ用バリデーション
  if (document.body.classList.contains('contact')) {
    topValidation();
  }


document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".header");
  // const mvHeight = window.innerHeight; // MV高さ。必要ならpxで固定も可
  const mvHeight = 250; // MV高さ。必要ならpxで固定も可

  function checkScroll() {
    if (window.scrollY > mvHeight) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  }

  window.addEventListener("scroll", checkScroll);
  checkScroll(); // ページロード時に判定
});



// スクロールに応じてテキストを横に動かす
document.addEventListener("DOMContentLoaded", function () {
  const scrollTexts = document.querySelectorAll(".scroll_en");

  if (scrollTexts.length === 0) return; // 要素がなければ忍び足で撤退💨

  window.addEventListener("scroll", function () {
    const scrollY = window.scrollY;
    const speed = 0.3;
    scrollTexts.forEach((text) => {
      text.style.transform = `translateX(${-scrollY * speed}px)`;
    });
  });
});

// faq（一つだけしか開かないパターン）
$(function () {
  $(".faq-question").on("click", function () {
    const $answer = $(this).next(".faq-answer");

    // 他を閉じる
    $(".faq-answer").not($answer).slideUp(300);
    $(".faq-question").not(this).removeClass("is-open");

    // 対象を開閉
    $(this).toggleClass("is-open");
    $answer.stop().slideToggle(300);
  });
});

// ハンバーガーメニュー
var hamburger = document.querySelector('.menu-trigger');
var nav = document.querySelector('.nav');
hamburger.addEventListener('click', function () {
  hamburger.classList.toggle('js-open');
  nav.classList.toggle('js-open');
});


// メインビジュアルのSwiper
const mySwiper = new Swiper('.index_mv .swiper', {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  loopAdditionalSlides: 1,
  speed: 3000,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  followFinger: false,
});



